import { dictionary } from './dictionary';

export const errorDictionary = dictionary;
